// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".M27W{position:relative;padding:2rem 0}@media (min-width:48em){.M27W{padding:4rem 0}}@media (min-width:62em){.M27W{padding:6rem 0}}._3NZK{order:2}@media (min-width:62em){._3NZK{order:1}}@media (min-width:48em){._101J{order:2}}._1xDj{max-width:420px;margin:0 auto;text-align:center}._1fiV{max-width:330px;margin:.8rem auto}._3jaR{display:flex;justify-content:center}._1OOH{order:1}@media (min-width:62em){._1OOH{order:2}}@media (min-width:48em){.o68f{order:1}}._2Ypx{margin:2.4rem auto;display:block}@media (min-width:48em){._2Ypx{margin:0 auto}}.DPPC{width:7.2rem;position:absolute;right:0;top:0}@media (min-width:36em){.DPPC{width:9.6rem}}._1b3R{width:350px}html[dir=rtl] .DPPC{right:auto;left:0}", ""]);
// Exports
exports.locals = {
	"wrapp": "M27W",
	"contentWrapp": "_3NZK",
	"contentWrapp__TO_RIGHT": "_101J",
	"content": "_1xDj",
	"description": "_1fiV",
	"iconsWrapp": "_3jaR",
	"imageWrapp": "_1OOH",
	"imageWrapp__TO_LEFT": "o68f",
	"image": "_2Ypx",
	"warrantyIcon": "DPPC",
	"btn": "_1b3R"
};
module.exports = exports;
